// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2exlk","header":"ClearentDisclaimer_header__keazs","inner":"ClearentDisclaimer_inner__2Q4eo"};